<template>
  <div id="app" style="overflow:hidden">
    <b-navbar class="bgColorPrimary" :shadow="true" fixed-top>
    <template #brand>
        <b-navbar-item tag="router-link" :to="{ path: '/' }">
            <img src="@/assets/img/logo.png"
            class="is-hidden-tablet"
            > 
            <button
            class="is-inline-block bgTransparent borderTransparent is-hidden-tablet width70"
            onclick="window.location.href='tel:+542213088411'">
              <p class="is-size-7 mt-1 letterSpacingLarge fontWeightBold fontUpperCase fontPrimary">
                <font-awesome-icon icon="phone" class="is-size-7 iconMenu colorBlack ml-2" />  Llamanos
              </p>
            </button>
        </b-navbar-item>
    </template>        
      <template slot="start">
        <img src="@/assets/img/isologo.png"
        class="fade-in logo is-hidden-mobile"
        > 
        <div v-for="(item, key) of items" :key="key" class="paddingMenu">
          <a
            :href="item.to.name"
            exact-active-class="is-active"
            class="pl-3"
          >
            <font-awesome-icon :icon="item.icon" class="iconMenu has-text-dark ml-2" /> 
                <span class="has-text-dark letterSpacingShort fontWeightRegular fontUpperCase">
                {{ item.title }}
                </span>
          </a>
        </div>
      </template>
      <template slot="end">
        <b-navbar-item tag="div">
          <div class="buttons">
            <a :href="brand.whatsappUrl">
              <b-button class="button3d bgColorSecondary has-text-white noBorder fontPrimary width100 pr-4">
                <img src="@/assets/img/whatsapp.webp" class="whatsappTopButton">
                Pedir presupuesto
                <span class="is-hidden-mobile">por</span>
                Whatsapp
              </b-button>
            </a>
          </div>
        </b-navbar-item>
      </template>
    </b-navbar>
    <router-view/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    data () {
        return {
            items: [
            {
                title: 'Inicio',
                icon: 'home',
                to: { name: '#inicio' }
            },
            {
                title: 'Servicios',
                icon: 'toolbox',
                to: { name: '#services' }
            },
            {
                title: 'Testimonios',
                icon: 'check-circle',
                to: { name: '#comments' }
            },
            {
                title: 'Nosotros',
                icon: 'user',
                to: { name: '#us' }
            },
            {
                title: 'Contacto',
                icon: 'envelope',
                to: { name: '#contacto' }
            }
            ]
        }
    },
    metaInfo() {
        return {
            title: "LF Soluciones",
        }
    },
    computed: {
        ...mapState('brand', ['brand'])
    }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
